import HeroSection from '../components/sections/HeroSection'
import FinderSliderSection from '../components/sections/FinderSliderSection'
import ShopByCategorySection from '../components/sections/ShopByCategorySection'
import GemstoneCategoriesSection from '../components/sections/GemstoneCategoriesSection'
import RudrakshaSection from '../components/sections/RudrakshaSection'
import BestsellersSection from '../components/sections/BestsellersSection'
import DiscountBannerSection from '../components/sections/DiscountBannerSection'
import CertificationSection from '../components/sections/CertificationSection'
import PoojaEnergizationSection from '../components/sections/PoojaEnergizationSection'
import ConsultationHubSection from '../components/sections/ConsultationHubSection'
import AcademySection from '../components/sections/AcademySection'
import TestimonialsSection from '../components/sections/TestimonialsSection'
import FaqSection from '../components/sections/FaqSection'
import CoreValuesSection from '../components/sections/CoreValuesSection'

export default function ShopHome() {
  return (
    <>
      <HeroSection />
      <FinderSliderSection />
      <ShopByCategorySection />
      <GemstoneCategoriesSection />
      <RudrakshaSection />
      <BestsellersSection />
      <DiscountBannerSection />
      <CertificationSection />
      <PoojaEnergizationSection />
      <ConsultationHubSection />
      <AcademySection />
      <TestimonialsSection />
      <FaqSection />
      <CoreValuesSection />
    </>
  )
}
